export default {
    props:{
        config:Object
    }
}


// WEBPACK FOOTER //
// ./src/components/booking/preview-footer/preview-footer.js